
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-engagementaccessrequest',
  standalone: true,
  imports: [KENDO_DIALOGS, KENDO_BUTTONS],
  templateUrl: './engagementaccessrequest.component.html',
  styleUrl: './engagementaccessrequest.component.scss'
})
export class EngagementaccessrequestComponent {
  @Input() isEngagementAccessRequestOpen!:boolean;
  @Output() closeEvent :EventEmitter<boolean> = new EventEmitter<boolean>();

  requestEngagementAccess(provideAccess:boolean):void{
    this.closeEvent.emit(provideAccess);
  }
}
